"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerHyperview = void 0;
function registerHyperview(props) {
    WidgetFramework.WidgetManager.registerProductWidget(function (widget) {
        widget.onHyperviewLoaded = function (_a) {
            var entityData = _a.entityData, hyperview = _a.hyperview, hyperviewContext = _a.hyperviewContext;
            var hyperviewEntityData = {
                id: hyperviewContext.instanceId,
                organisationId: hyperviewContext.organisation.id,
                uri: hyperviewContext.toUri(),
                definition: {
                    displayName: entityData.entity.displayName,
                    name: entityData.entity.name
                },
                title: entityData.summary.primary,
                image: entityData.image,
                keys: hyperviewContext.keys,
                properties: entityData.properties,
                summary: entityData.summary
            };
            props.load({ hyperview: hyperview, entityData: hyperviewEntityData, settings: widget.settings });
        };
    });
}
exports.registerHyperview = registerHyperview;
